import React from 'react';
import { isEmpty } from 'lodash';

const checkNegativeBalance = (balance) =>
  balance.startsWith('-') ? (
    <span>&minus;{balance.substring(1)}</span>
  ) : (
    balance
  );

export const BalancePreviousBusinessDay = ({ account, balances }) => {
  if (account.type === 'current' || account.type === 'savings') {
    if (
      balances.closingBalancePreviousBusinessDay !== null &&
      balances.clearedBalancePreviousBusinessDay !== null &&
      !isEmpty(balances.closingBalancePreviousBusinessDay) &&
      !isEmpty(balances.clearedBalancePreviousBusinessDay)
    ) {
      return (
        <div className="account-summary__more__balances cardsticky__hide">
          <h5 className="account-summary__more__previousinfo cardsticky__hide">
            Close of previous business day
          </h5>
          <div className="account-summary__more__balances__details">
            <dl>
              <dt>Balance</dt>
              <dd>
                {checkNegativeBalance(
                  balances.closingBalancePreviousBusinessDay
                )}
              </dd>
            </dl>
            <dl>
              <dt>Cleared balance</dt>
              <dd>
                {checkNegativeBalance(
                  balances.clearedBalancePreviousBusinessDay
                )}
              </dd>
            </dl>
          </div>
        </div>
      );
    }
  }

  return null;
};
